import LocalizationResourceCache from './localization-resource-cache';

export default class LocalizationManager extends LocalizationResourceCache {

    constructor(localizationConfig, xhrGet) {
        super(localizationConfig, xhrGet);

        this.defaultCulture = localizationConfig.config.defaultCulture;
        this.currentCulture = localizationConfig.config.currentCulture;

        this.loadPromise = null;
        if (localizationConfig.config.loadResources) {
            this.loadPromise = this._loadDefaultCulture().then(() => {
                return this._loadCurrentCulture();
            });
        }

        this.localizationTasks = [];
    }

    setDefaultCulture(culture) {
        this.defaultCulture = culture;
        return this._loadDefaultCulture();
    }

    _loadDefaultCulture() {
        return this.loadResources(this.defaultCulture);
    }

    _loadCurrentCulture() {
        return this.loadResources(this.currentCulture)
            .then(
                (result) => {
                    return result;
                },
                () => {
                    return this.loadResources(this.defaultCulture);
                });
    }

    _runCurrentCultureTask(task) {
        return task(this.currentCulture)
            .then(
                (result) => {
                    return result;
                },
                () => {
                    return task(this.defaultCulture);
                });
    }

    setCurrentCulture(culture) {
        this.currentCulture = culture;

        const localizationPromises = [this._loadCurrentCulture()];

        this.localizationTasks
            .map((task) => {
                const localizationTaskRunner = this._runCurrentCultureTask(task);

                localizationPromises.push(localizationTaskRunner);
            });

        this.loadPromise = Promise.all(localizationPromises);
        return this.loadPromise;
    }

    _getResourceString(key) {
        let resourceString = this.getResource(this.currentCulture, key);

        if (resourceString === null) {
            resourceString = this.getResource(this.defaultCulture, key);
        }
        if (resourceString === null) {
            resourceString = key;
        }

        return resourceString;
    }

    containsKey(key) {
        if (!key) {
            return false;
        }

        return this.getResource(this.defaultCulture, key) !== null;
    }

    getString(key, options) {
        // guard clause
        if (key === undefined || key === null) {
            return '';
        }

        // get pluralized key
        var pluralizedKey = key;

        if (options && options.count !== undefined
            && options.count !== null
            && Number.isInteger(options.count)) {

            if (options.count === 0 || options.count === 1) {
                pluralizedKey += '-singular';
            } else if (options.count > 1) {
                pluralizedKey += '-plural';
            }

        }

        var keyFound = this.containsKey(pluralizedKey);

        // if the pluralized key exists and options.params is specified, do a recursive call,
        //   fallback to pluralized key and string format arguments
        if (keyFound && options && options.params !== undefined) {
            var optionsParams = options.params ? options.params : [];
            var params = [].concat.apply([pluralizedKey], optionsParams);

            // NOTE: we do not pass options.default to the recursive call because keyFound == true
            return this.getString.apply(this, params);
        }

        // use options.default if needed and specified, otherwise get resource string
        let resourceString;

        if (!keyFound && options && options.default !== undefined && options.default !== null) {
            resourceString = options.default;
        } else {
            resourceString = this._getResourceString(pluralizedKey);
        }

        // replace string format arguments
        let args;

        if (options && options.params !== undefined) {
            args = options.params;
        } else {
            args = (Array.prototype.slice.call(arguments)).slice(1);
        }

        args
            .filter(arg => {
                return arg !== undefined;
            })
            .map((arg, index) => {
                let argRegexp, argValue;

                argRegexp = new RegExp('\\{' + index + '\\}', 'g');
                argValue = arg.toString();

                resourceString = resourceString.replace(argRegexp, argValue);
            });

        return resourceString;
    }
}



/** WEBPACK FOOTER **
 ** ./src/localization/core/localization-manager.js
 **/